export default function ProductCarriers() {
  return {
    productCategory: 'UL',
    productCarrierData: [
      {
        carrierName: "Corebridge",
        displayOrder: 1,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/corebridge.png",
      },
      {
        carrierName: "Equitable",
        displayOrder: 2,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/Equitable.jpg",
      },
      {
        carrierName: "John hancock",
        displayOrder: 3,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/john-hancock.png",
      },
      {
        carrierName: "Lincoln",
        displayOrder: 4,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/lincoln.png",
      },
      {
        carrierName: "Nationwide",
        displayOrder: 5,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/nationwide.png",
      },
      {
        carrierName: "Pacific life",
        displayOrder: 6,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/pacific-life.png",
      },
      {
        carrierName: "Protective",
        displayOrder: 7,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/protective.png",
      },
      {
        carrierName: "Securian",
        displayOrder: 8,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/securian.png",
      },
      {
        carrierName: "Symetra",
        displayOrder: 9,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/symetra.png",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 10,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/transamerica.png",
      },
    
    ],
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/UniversalLife/ProductCarriers.js